import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faArrowRight, faCalendarAlt, faCalendarCheck, faDollarSign, faEdit, faFilter, faHashtag, faPlus, faSave, faSync, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        loadDepartamento: true,
        datosCargados: false,
        nic: '',
        id_departamento: '',
        id_municipio: '',
        departamentosConsulta: [],
        municipiosConsulta: [],
        consultaGeneradaDepartamento: [],
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }

    generateExcelBalanceFlujo(){
        const { id_departamento, id_municipio, municipiosConsulta, departamentosConsulta } = this.state;
        const selectedMunicipio = municipiosConsulta.find(municipio => municipio.ID_MUNICIPIO === Number(id_municipio))
        const selectedDepartamente = departamentosConsulta.find(departamento => departamento.ID_DEPARTAMENTO === Number(id_departamento))
        const municipio = selectedMunicipio.NOMBRE; 
        const departamento = selectedDepartamente.NOMBRE;
        const filename = `Informe Histórico Balance de Flujo. ${departamento} - ${municipio}.xlsx`;
        const data = {id_departamento:id_departamento, id_municipio:id_municipio}
        Swal.showLoading();
        authAxios
            .post(`excel_reports/generate-excel-balance-flujo`, data, {
                responseType: 'blob' // Set the response type to 'blob'
            })
            .then((response) => {
                var status = response.data.status
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                // Create a download link for the blob
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                // Trigger the download link
                link.click();
                Swal.close();
                // Cleanup the link and object URL
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                Swal.close();
            });
    }

    consultarDepartamento = () => {
        this.setState({
            consultaGeneradaDepartamento: [],
            loadDepartamento: true
        });
        const { id_departamento, id_municipio } = this.state;
        var errores = [];
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        Swal.showLoading();
        authAxios.get("consultas/balance_flujo/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    datosCargados: true,
                    load: '',
                    consultaGeneradaDepartamento: datosRespuesta.data.resultAll,
                    loadDepartamento: false
                });
            })
            .catch(console.log);
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('id_departamento').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipiosConsulta: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
   
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosConsulta: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, loadDepartamento, departamentosConsulta, municipiosConsulta, consultaGeneradaDepartamento } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            &nbsp;
                        </div>
                        <div className="card-body">
                            <h4>Balance de Flujo</h4>
                            <hr />
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-departamento-tab" data-bs-toggle="pill" data-bs-target="#pills-departamento" type="button" role="tab" aria-controls="pills-departamento" aria-selected="false">Por Departamento</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fad show active" id="pills-departamento" role="tabpanel" aria-labelledby="pills-departamento-tab">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className='row g-3'>
                                                        <div className='col-md-3'>
                                                            <label htmlFor="id_departamento">Departamento</label>
                                                            <select name="id_departamento"
                                                                id="id_departamento"
                                                                className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                onChange={e => {
                                                                    this.cargarMunicipios(e);
                                                                    this.cambioValor(e)
                                                                }}>
                                                                <option value="">Seleccione el Departamento</option>
                                                                {
                                                                    departamentosConsulta.map((itemDepartamentosConsulta) => (
                                                                        <option key={itemDepartamentosConsulta.ID_TABLA} value={itemDepartamentosConsulta.ID_DEPARTAMENTO}>{itemDepartamentosConsulta.NOMBRE}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <label htmlFor="id_municipio">Municipio</label>
                                                            <select name="id_municipio"
                                                                id="id_municipio"
                                                                className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                <option value="">Seleccione el Municipio</option>
                                                                {
                                                                    municipiosConsulta.map((itemMunicipiosConsulta) => (
                                                                        <option key={itemMunicipiosConsulta.ID_TABLA} value={itemMunicipiosConsulta.ID_MUNICIPIO}>{itemMunicipiosConsulta.NOMBRE}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                        </div>
                                                        <div className='col-md-2'>
                                                            <label htmlFor="">&nbsp;</label>
                                                            <div className="input-group input-group-sm">
                                                                <button type='button' id="consultarDepartamento" name="consultarDepartamento" className="btn btn-secondary btn-sm" onClick={() => this.consultarDepartamento()}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Consultar</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr style={{ marginBottom: 0 }} />
                                                    <div style={{ fontSize: 14 }} className="card-header text-center">
                                                        <b>RESULTADO CONSULTA</b>
                                                    </div>
                                                    <div style={{ marginTop: 0 }} className='row g-3'>
                                                        <div className='col-md-12'>
                                                            <div className='table-responsive'>
                                                                <table className="table table-hover table-condensed table-sm">
                                                                    <thead className="thead-inverse">
                                                                        <tr>
                                                                            <th className="align-middle">PERIODO</th>
                                                                            <th className="align-middle">INGRESOS</th>
                                                                            <th className="align-middle">EGRESOS</th>
                                                                            <th className="align-middle">DIFERENCIA</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            consultaGeneradaDepartamento.map((itemConsultaGeneradaDepartamento, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{itemConsultaGeneradaDepartamento.resultUnion}</td>
                                                                                    <td><b>$ </b>{currencyFormat(itemConsultaGeneradaDepartamento.totalIngresos)}</td>
                                                                                    <td><b>$ </b>{currencyFormat(itemConsultaGeneradaDepartamento.totalEgresos)}</td>
                                                                                    <td><b>$ </b>{currencyFormat(itemConsultaGeneradaDepartamento.diferencia)}</td>
                                                                                </tr>
                                                                            ))
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div className='row'>
                                                        <div className='col-xl-12 text-center'>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <button type="button" onClick={() => this.generateExcelBalanceFlujo()} className="btn btn-success btn-sm" disabled={loadDepartamento ? true : false}><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Generar Excel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-muted">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;